import { AuthServices } from '@/features/auth/services';
import { auth } from '@/features/auth/types';

/** Signed-in guardian's profile, from `GET /api/v1/guardians/me` (`GuardianProfileResponseDto`). */
export type GuardianProfile = auth.GuardianProfileResponse;

export async function fetchGuardianMe(): Promise<GuardianProfile> {
  return await AuthServices.getGuardianInfo();
}
